export default __webpack_public_path__ + "static/media/externalLink.ff63ce2b.svg";